import { CardSubWrapper, CardWrapper } from 'admin/components/wrappers';
import CustomDataGrid from 'app/components/CustomDataGrid/Index';
import React from 'react';
import { FinancialReportResponse } from 'services/openapi';
import styled from 'styled-components';
import { useNavigateToRoute } from 'utils/common';
import { GridSortChangeEvent } from '@progress/kendo-react-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import { usePermission } from 'hooks/usePermission';
import Cookies from 'js-cookie';
import AmountCell from 'app/components/CustomDataGrid/Cells/AmountCell';
import NameProfileCell from 'app/components/CustomDataGrid/Cells/NameProfileCell';
import StatusBadgeCell from './StatusBadge';

type Props = {
    financialReportList?: FinancialReportResponse;
    setPageSkip: React.Dispatch<React.SetStateAction<number | undefined>>;
    pageSkip: number | undefined;
    fetchFinancialReportList: (
        page?: number,
        limit?: number,
        searchInput?: string,
        paymentStatus?: string,
        payerType?: string,
    ) => void;
    debounceTeamSearch: string;
    sortField: string | undefined;
    sortOrder: number | undefined;
    setSortField: React.Dispatch<React.SetStateAction<string>>;
    setSortOrder: React.Dispatch<React.SetStateAction<number>>;
    loading: boolean;
    paidFilter?: string;
    setType?: React.Dispatch<React.SetStateAction<string | undefined>>;
    type?: string;
    pageSize: number;
};

const DataTable = ({
    financialReportList,
    setPageSkip,
    pageSkip,
    fetchFinancialReportList,
    debounceTeamSearch,
    sortField,
    sortOrder,
    setSortField,
    setSortOrder,
    loading,
    paidFilter,
    setType,
    type,
    pageSize,
}: Props) => {
    const redirect = useNavigateToRoute();
    const { hasViewPermission } = usePermission();
    const initialSort: Array<SortDescriptor> = [
        { field: 'teamName', dir: 'asc' },
    ];
    const [sort, setSort] = React.useState<Array<SortDescriptor>>(initialSort);
    const userType = Cookies.get('userType') ?? '';
    const handleRowClick = () => { };

    const handleViewClick = id => { };

    const handleSortChange = e => {
        let sortOrderValue = e.dir === 'asc' ? 0 : 1;
        setSortOrder(sortOrderValue);
        setSortField(e.field);
    };

    const TeamsColumn = [
        {
            field: 'name',
            title: 'Name',
            cell: e => (
                <NameProfileCell
                    e={e}
                    onClick={handleRowClick}
                    teamName={e.dataItem.name}
                // imageUrl={e.dataItem.profileImageUrl}
                />
            ),
            width: '220',
            sortable: false,
        },
        {
            field: 'type',
            title: 'Type',
            cell: e => <StatusBadgeCell type="type" e={e} onClick={handleRowClick} />,
            width: '180',
            sortable: false,
        },
        {
            field: 'paymentStatus',
            title: 'Payment Status',
            cell: e => (
                <StatusBadgeCell type="paymentStatus" e={e} onClick={handleRowClick} />
            ),
            width: '180',
            sortable: false,
        },
        {
            field: 'amount',
            title: 'Amount',
            cell: e => (
                <AmountCell
                    e={e}
                    onClick={handleRowClick}
                    amount={`$${e.dataItem.amount}`}
                />
            ),
            width: '180',
            sortable: false,
        },
    ];

    const handlePageChange = event => {
        setPageSkip(event.page.skip);
        fetchFinancialReportList(
            event.page.skip,
            pageSize,
            debounceTeamSearch,
            paidFilter,
            type,
        );
    };
    return (
        <>
            {loading ? (
                <TableSkeletonLoader rowContent={8} width={100} headingWidth={80} />
            ) : (
                <CardWrapper style={{ paddingTop: '5px' }}>
                    <CardSubWrapper className="d-flex"></CardSubWrapper>
                    <GridWrapper>
                        <CustomDataGrid
                            showPagination
                            data={financialReportList?.items ?? []}
                            columns={TeamsColumn}
                            pageSize={pageSize}
                            totalCount={financialReportList?.pageDetails?.count}
                            onPageChange={event => {
                                handlePageChange(event);
                            }}
                            skip={pageSkip}
                            sortable={{
                                allowUnsort: false,
                                mode: 'single',
                            }}
                            sort={sort}
                            onSortChange={(e: GridSortChangeEvent) => {
                                let sortvalue = e.sort[0];
                                setSort(e.sort);
                                handleSortChange(sortvalue);
                            }}
                        />
                    </GridWrapper>
                </CardWrapper>
            )}
        </>
    );
};

export default DataTable;

const GridWrapper = styled.div`
  .k-grid-container {
    height: calc(100vh - 448px);
    @media (max-width: 1040px) {
      height: calc(100vh - 440px);
    }
  }
  .k-table-thead {
    .k-link {
      cursor: default;
    }
    .coach-header-style,
    .team-header-style {
      cursor: pointer !important;
      .k-link {
        cursor: pointer !important;
      }
    }
  }
`;
